import SUPPLIER_ERROR_DETAIL from "./custom_table";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TableChartIcon from "@mui/icons-material/TableChart";

export const inf_partner = [

    {
        label: "Table",
        accessor: "details",
        sm: 30,
        dfl: "",
        type: "custom",
        data_select: [],
        name_select: "",
        section: "custom",
        sectionTitle: "Roles",
        change: true,
        required: false,
        maxLength: 1000,
        minLength: 0,
        visible: true,
        customComponent: SUPPLIER_ERROR_DETAIL,
        method: "ALL",
        icon: TableChartIcon,
    }
];
